import Container from '@components/container'
import {
  StyleAuthActionWrapper,
  StyleAuthRow,
  StyleAuthWrapper,
  StyleLink,
} from '../style'
import AuthBanner from '../components/banner'
import AuthHeader from '../components/header'
import AuthFooter from '../components/footer'
import { Formik, Form } from 'formik'
import Column from '@components/column'
import Fields from '@components/fields'
import Button from '@components/button'
import Row from '@components/row'
import { AuthSchema } from '@validations'
import { useLocation, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { Admin, User } from '@apis'
import { Helper } from '@utils'
import SeoHead from '@pages/front/shared/SeoHead/SeoHead'
import { useSeoData } from '@pages/front/hook/useSeoData'
const LoginPage = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [fcmToken, setFcmToken] = useState<any>('')
  const { pathname } = useLocation()
  const isAdminLogin = pathname.includes('admin-login') ? true : false

  const navigate = useNavigate()

  const fetchFCMToken = async () => {
    try {
    } catch (error) {
      console.error('Error fetching FCM token:', error)
    }
  }
  const submitHandler = async (values) => {
    setLoading(true)
    const payload: any = {
      username: values.username,
      password: values.password,
    }
    if (!!fcmToken) {
      payload.deviceToken = fcmToken
    }
    if (!!isAdminLogin) {
      await Admin.login({
        data: payload,
      })
        .then(async (resp) => {
          await Helper.saveUser(resp)
          navigate(`/${resp?.role}`)
        })
        .catch(() => {})
    } else {
      await User.login({
        data: payload,
      })
        .then(async (resp) => {
          await Helper.saveUser(resp)
          navigate(`/${resp?.role}`)
        })
        .catch(() => {})
    }

    setLoading(false)
  }

  useEffect(() => {
    fetchFCMToken()
  }, [])
  const seo = useSeoData('login-seo', 'loginSeo')
  return (
    <>
      <SeoHead seo={seo} />
      <StyleAuthWrapper>
        <Container>
          <StyleAuthRow>
            <AuthBanner />
            <StyleAuthActionWrapper>
              <AuthHeader
                title="Login to Continue with"
                tag="Supachar"
                subTitle="Connecting You to What Matters"
              />
              <Formik
                initialValues={{
                  username: '',
                  password: '',
                  deviceToken: '',
                }}
                onSubmit={submitHandler}
                validationSchema={AuthSchema.loginValidationSchema}
              >
                {({ handleSubmit }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Column rowGap={20}>
                        <Fields.Input
                          name="username"
                          label={
                            !!isAdminLogin ? 'Username' : 'Mobile or Email'
                          }
                          placeholder={
                            !!isAdminLogin ? 'Username' : 'Mobile or Email'
                          }
                        />
                        <Fields.Password
                          name="password"
                          label="Password"
                          placeholder="Password"
                        />
                        <Row
                          justifyContent="space-between"
                          styleRow="margin-bottom:30px;"
                        >
                          <Column>
                            <Fields.Checkbox
                              name="remember"
                              label="Remember Me"
                            />
                          </Column>
                          {!isAdminLogin && (
                            <StyleLink
                              to="/phone"
                              state={{
                                purpose: 'ResetPassword',
                              }}
                            >
                              Forgot Password ?
                            </StyleLink>
                          )}
                        </Row>
                        <Column>
                          <Button
                            type="submit"
                            title="Login"
                            styleButton="width:100%"
                            height={40}
                            loading={loading}
                          />
                        </Column>
                        {!isAdminLogin && (
                          <AuthFooter
                            title="Don't have an Account ? "
                            linkTitle="Signup Now"
                            to="/phone"
                          />
                        )}
                      </Column>
                    </Form>
                  )
                }}
              </Formik>
            </StyleAuthActionWrapper>
          </StyleAuthRow>
        </Container>
      </StyleAuthWrapper>
    </>
  )
}

export default LoginPage
